import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="201.2177277" cy="193.0447998" r="0" />
				<g className="fill--eyes eyes">
					<ellipse cx="171.2177277" cy="193.0447998" rx="7.6592607" ry="8.5102901" />
					<ellipse cx="231.2177277" cy="193.0447998" rx="7.6592607" ry="8.5102901" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M178.8534698,199.0294952c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484
						c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992
						l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867
						C181.0800323,198.1935577,180.0312042,199.0294952,178.8534698,199.0294952z" />
					<path d="M223.5819855,199.0294952c0.1542969,0,0.3105469-0.0141602,0.4677734-0.0439453l15.265625-2.8896484
						c1.3564453-0.2568359,2.2480469-1.5649414,1.9912109-2.9213867c-0.2568359-1.3569336-1.5634766-2.2470703-2.9208984-1.9916992
						l-15.265625,2.8896484c-1.3564453,0.2568359-2.2480469,1.5649414-1.9912109,2.9213867
						C221.355423,198.1935577,222.4042511,199.0294952,223.5819855,199.0294952z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M178.6112061,198.8965759c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797
						c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906
						c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586
						c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125
						c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266
						C179.9598389,198.6246033,179.2869873,198.8965759,178.6112061,198.8965759z" />
					<path d="M223.8242493,198.8965759c0.6044922,0,1.2099609-0.2177734,1.6904297-0.6591797
						c0.9189453-0.84375,2.9033203-1.7983398,5.7177734-1.9462891c2.8125-0.1425781,4.8876953,0.5942383,5.8896484,1.3378906
						c1.1103516,0.8237305,2.6748047,0.5908203,3.4970703-0.5170898c0.8232422-1.1083984,0.5917969-2.6743164-0.5166016-3.4975586
						c-2.234375-1.6591797-5.5507812-2.5053711-9.1318359-2.3164062c-3.5683594,0.1875-6.7900391,1.375-8.8388672,3.2578125
						c-1.0166016,0.934082-1.0839844,2.515625-0.1494141,3.5322266
						C222.4756165,198.6246033,223.148468,198.8965759,223.8242493,198.8965759z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M178.8769836,193.0447998c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844
						c-4.2301025,0-7.6592712-3.8101807-7.6592712-8.5102844c0-3.0506287,3.4291687-3.0506287,7.6592712-3.0506287
						C175.4478149,189.9941711,178.8769836,189.9941711,178.8769836,193.0447998z" />
					<path d="M238.8769836,193.0447998c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844
						c-4.2301025,0-7.6592712-3.8101807-7.6592712-8.5102844c0-3.0506287,3.4291687-3.0506287,7.6592712-3.0506287
						C235.4478149,189.9941711,238.8769836,189.9941711,238.8769836,193.0447998z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Leopard/Eyes.js